import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";

// Informative cookie notice (no consent categories). Dismissal persisted in localStorage.
const KEY = "mc_cookie_notice";
const COPY = {
  pt: { text: "🍪 Utilizamos cookies e tecnologias semelhantes para melhorar sua experiência, lembrar suas preferências e entender como a plataforma é utilizada.", link: "Política de Privacidade", btn: "Entendi" },
  "pt-PT": { text: "🍪 Utilizamos cookies e tecnologias semelhantes para melhorar a sua experiência, guardar as suas preferências e compreender como a plataforma é utilizada.", link: "Política de Privacidade", btn: "Entendi" },
  en: { text: "🍪 We use cookies and similar technologies to improve your experience, remember your preferences, and understand how the platform is used.", link: "Privacy Policy", btn: "Got it" },
  es: { text: "🍪 Utilizamos cookies y tecnologías similares para mejorar su experiencia, recordar sus preferencias y comprender cómo se utiliza la plataforma.", link: "Política de Privacidad", btn: "Entendido" },
  fr: { text: "🍪 Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience, mémoriser vos préférences et comprendre comment la plateforme est utilisée.", link: "Politique de confidentialité", btn: "J'ai compris" },
  it: { text: "🍪 Utilizziamo cookie e tecnologie simili per migliorare la tua esperienza, ricordare le tue preferenze e comprendere come viene utilizzata la piattaforma.", link: "Informativa sulla privacy", btn: "Ho capito" },
};

export default function CookieNotice() {
  const { lang } = useI18n();
  const [open, setOpen] = useState(() => { try { return !localStorage.getItem(KEY); } catch { return true; } });
  const [offset, setOffset] = useState(0);

  // Sit above the landing's mobile sticky CTA so the main CTA is never covered.
  useEffect(() => {
    if (!open) return;
    const measure = () => { const el = document.querySelector('[data-testid="v2-sticky-cta"]'); setOffset(el && getComputedStyle(el).display !== "none" ? el.offsetHeight : 0); };
    measure();
    const obs = new MutationObserver(measure); obs.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("resize", measure);
    return () => { obs.disconnect(); window.removeEventListener("resize", measure); };
  }, [open]);

  if (!open) return null;
  const C = COPY[lang] || COPY.pt;
  const dismiss = () => { try { localStorage.setItem(KEY, "1"); } catch {} setOpen(false); };

  return (
    <div className="pointer-events-none fixed inset-x-0 z-[60] px-2 pb-2 sm:px-4 sm:pb-4" style={{ bottom: offset }} data-testid="cookie-notice" role="region" aria-label={C.link}>
      <div className="pointer-events-auto mx-auto flex max-w-4xl items-center gap-3 rounded-xl border border-xmas-gold/25 bg-xmas-navy/95 px-3 py-2 shadow-2xl backdrop-blur-xl sm:gap-5 sm:rounded-2xl sm:px-5 sm:py-3">
        <p className="line-clamp-2 flex-1 text-[11px] leading-snug text-xmas-champagne sm:line-clamp-none sm:text-sm sm:leading-relaxed" data-testid="cookie-notice-text">
          {C.text} <Link to="/privacy" data-testid="cookie-notice-privacy-link" className="font-medium text-xmas-gold underline-offset-4 hover:underline">{C.link}</Link>
        </p>
        <button onClick={dismiss} data-testid="cookie-notice-accept" className="btn-gold shrink-0 rounded-full px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider sm:px-5 sm:py-2 sm:text-xs">{C.btn}</button>
      </div>
    </div>
  );
}
